const NavInstagramIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.3741 9.51587C21.3741 10.3117 22.0267 10.9601 22.8267 10.9601C23.6267 10.9601 24.278 10.3117 24.278 9.51587C24.278 8.71727 23.6267 8.06885 22.8267 8.06885C22.0267 8.06885 21.3741 8.71727 21.3741 9.51587ZM9.81341 16.4632C9.81341 19.7531 12.4913 22.4282 15.7811 22.4282C19.0724 22.4282 21.7488 19.7531 21.7488 16.4632C21.7488 13.1734 19.0724 10.4983 15.7811 10.4983C12.4913 10.4983 9.81341 13.1734 9.81341 16.4632ZM10.0801 2.66675H21.9187C26.3538 2.66675 29.3334 5.78534 29.3334 10.4281V21.572C29.3334 26.2134 26.3524 29.3334 21.9173 29.3334H10.0801C5.6464 29.3334 2.66675 26.2134 2.66675 21.572V10.4281C2.66675 5.78534 5.6464 2.66675 10.0801 2.66675ZM11.918 16.463C11.918 14.3338 13.6515 12.6033 15.782 12.6033C17.9125 12.6033 19.6444 14.3338 19.6444 16.463C19.6444 18.5921 17.9125 20.3226 15.782 20.3226C13.6515 20.3226 11.918 18.5921 11.918 16.463Z"
        fill="url(#paint0_linear_15183_166100)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_15183_166100"
          x1="16.0001"
          y1="2.66675"
          x2="16.0001"
          y2="29.3334"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#89B8F0" />
          <stop offset="1" stopColor="#165BAD" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default NavInstagramIcon
